export enum EDeviceSettingsPages {
	Audio = 'audio',
	Power = 'power',
	DisplayAndCamera = 'display-camera',
	InputAndAccessories = 'input-accessories'
}
